module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-selected-left.61385203.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Tabs/images/tab-selected-left.png
// module id = 3243
// module chunks = 11